import { CdpaButtonComponent, CdpaButtonId } from "../../../common/components/cdpaButton.component";
import { FormId } from "../common/formId";
import "./login-oauth-grant.scss";
export class LoginOauthGrant {
    constructor() {
        this.acceptButton = new CdpaButtonComponent(CdpaButtonId.LoginGrantAccept);
        this.denyButton = new CdpaButtonComponent(CdpaButtonId.LoginGrantDeny);
        this.acceptButton.onClick$.subscribe(() => {
            const form = document.getElementById(FormId.LoginOauthGrant);
            form.submit();
        });
        this.denyButton.onClick$.subscribe(() => {
            const form = document.getElementById(FormId.LoginOauthGrantCancel);
            form.submit();
        });
    }
}
